
export const generateWidgetActions = ({
  currentComp,
  hasBreakdown,
  currentBreakdownDisplayType,
  canAnnotate,
  // When true (tenant's aiAnnotation.mode is non-legacy — see getAnnoMode),
  // the Thematics/Attributes annotation views are exposed. Without this flag,
  // a single role-less "Annotation Counts" view is offered.
  hasExperimentalTopicModelling,
  // Split mode (aiAnnotation.mode === "split"): the Thematics/Attributes role
  // pair collapses into a single flat "Annotation Counts" view (all sub-themes
  // stacked), plus a "Topics" section over the observation-clustering tree.
  isSplitMode,
  taxonomyRole,
}) => {
    // Pie Chart -> Bar Chart
    if (currentComp === 'WidgetPieChart') {
      return [{
        display: "Bar Chart",
        value: "WidgetBarChart",
        icon: "ChartBarHorizontal"
      }];
    }

    // Bar Chart without breakdown -> Pie Chart
    if (currentComp === 'WidgetBarChart' && !hasBreakdown) {
      return [{
        display: "Pie Chart",
        value: "WidgetPieChart",
        icon: "ChartDonut"
      }];
    }

    // Bar Chart with breakdown -> Heat Map Grid + Stacked/Grouped toggle
    if (currentComp === 'WidgetBarChart' && hasBreakdown) {
      const isStacked = currentBreakdownDisplayType === "stacked";
      return [
        {
          display: "Heat Map Grid",
          value: "WidgetHeatMapGrid",
          icon: "GridNine"
        },
        {
          display: isStacked ? "Grouped Bar Chart" : "Stacked Bar Chart",
          value: "WidgetBarChart",
          breakdownDisplayType: isStacked ? "grouped" : "stacked",
          icon: isStacked ? "ChartBarHorizontal" : "Stack"
        }
      ];
    }

    // Heat Map -> Bar Chart
    if (currentComp === 'WidgetHeatMapGrid') {
      return [
        {
          display: "Stacked Bar Chart",
          value: "WidgetBarChart",
          type: "stacked",
          breakdownDisplayType: "stacked",
          icon: "Stack"
        },
        {
          display: "Grouped Bar Chart",
          value: "WidgetBarChart",
          type: "grouped",
          breakdownDisplayType: "grouped",
          icon: "ChartBarHorizontal"
        }
      ];
    }

    // WidgetAICategorization IS the annotations view (the comp key is kept for
    // saved-report compatibility).
    const isOnAnnotations = currentComp === "WidgetAICategorization";

    // Annotation actions.
    //   With non-legacy anno mode: Thematics + Attributes (taxonomy split).
    //     The current role is filtered out so we only surface the option the
    //     user is not already on.
    //   Split mode / legacy mode: a single "Annotation Counts" option, suppressed
    //     when it is already the current view.
    const annotationActions = () => {
      if (!canAnnotate) return [];
      if (hasExperimentalTopicModelling && !isSplitMode) {
        const currentRole = isOnAnnotations ? taxonomyRole : undefined;
        return [
          ...(currentRole !== "thematic"
            ? [{
                display: "Thematics",
                value: "WidgetAICategorization",
                taxonomyRole: "thematic",
                icon: "Bookmark",
              }]
            : []),
          ...(currentRole !== "attribute"
            ? [{
                display: "Attributes",
                value: "WidgetAICategorization",
                taxonomyRole: "attribute",
                icon: "Bookmark",
              }]
            : []),
        ];
      }
      return isOnAnnotations
        ? []
        : [{
            display: "Annotation Counts",
            value: "WidgetAICategorization",
            icon: "Bookmark",
            // taxonomyRole intentionally omitted → widget shows every sub-theme.
          }];
    };

    if (currentComp === "WidgetAISummary") {
      return annotationActions();
    }

    if (isOnAnnotations) {
      return [
        ...annotationActions(),
        {
          display: "AI Summary",
          value: "WidgetAISummary",
          icon: "MagicWand",
        },
      ];
    }

    return [];
  };
